/** Every locale Clavian ships. English is the only one. */
export const locales = ['en'];
/** The only locale, and the fallback i18next resolves to. */
export const fallbackLocale = 'en';
//# sourceMappingURL=types.js.map